// extracted by mini-css-extract-plugin
export default {"box":"Box_box__6XAdY","text":"Box_text__-53aS","bottom":"Box_bottom__UbLOh","right":"Box_right__Z3+3o","winning":"Box_winning__q4EIv","pulse":"Box_pulse__5MvhD"};